import Slider from 'js/components/Slider';
import $ from 'jquery';
import { sliderConfigs } from 'js/utils/settings';

Drupal.behaviors.related_scientists = {
  attach: (context) => {
    context
      .querySelectorAll('.paragraph--related-scientists .slider')
      .forEach((element) => {
        if (!element.Slider) {
          element.Slider = new Slider(
            element,
            sliderConfigs.related_scientists,
          );
        }
      });
    context
      .querySelectorAll('.paragraph--related-scientists .slider-4')
      .forEach((element) => {
        if (!element.Slider) {
          element.Slider = new Slider(
            element,
            sliderConfigs.related_scientists_four,
          );
        }
      });

    //Rezise for sliders <= 3

    var windowResize;
    window.addEventListener('resize', function () {
      clearTimeout(windowResize);
      windowResize = setTimeout(windowSize, 250);
    });

    function windowSize() {
      if (window.innerWidth <= 1025) {
        $('.paragraph--related-scientists .slider-3').each(function (item) {
          $(this).slick(sliderConfigs.related_scientists_three);
        });

        $('.paragraph--related-scientists .slider-2').each(function (item) {
          $(this).slick(sliderConfigs.related_scientists_two);
        });
      } else {
        if (
          $('.paragraph--related-scientists .slider-3').hasClass(
            'slick-initialized',
          )
        ) {
          $('.paragraph--related-scientists .slider-3').slick('unslick');
        }

        if (
          $('.paragraph--related-scientists .slider-2').hasClass(
            'slick-initialized',
          )
        ) {
          $('.paragraph--related-scientists .slider-2').slick('unslick');
        }
      }
    }
    windowSize();
  },
};
